import React, {useEffect} from "react";
import Breadcrumb from "../Components/Breadcrumb";
import PricingPlans from "../Components/PricingPlans";
import Faqs from "../Components/Faqs";
import Cta from "../Components/Cta";
import PricingTable from "../Components/PricingTable";
import SchemaMarkup from "../Components/SchemaMarkup";
import WebPageSchema from "../Schema/WebpageSchema";
import ItemListSchema from "../Schema/ItemListSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";
import OfferSchema from "../Schema/OfferSchema";

const Pricing=()=>{

useEffect(() => {
    document.title =
      "ONBBITS Pricing | Affordable WhatsApp API Plans";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Compare ONBBITS pricing plans and choose the right WhatsApp Business API solution with automation, broadcasts, analytics and team collaboration."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://onbbits.io/pricing");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "ONBBITS Pricing | Affordable WhatsApp API Plans"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Compare ONBBITS pricing plans and choose the right WhatsApp Business API solution with automation, broadcasts, analytics and team collaboration."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://onbbits.io/pricing");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://onbbits.io/Images/product-catalog.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "ONBBITS Pricing | Affordable WhatsApp API Plans"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Compare ONBBITS pricing plans and choose the right WhatsApp Business API solution with automation, broadcasts, analytics and team collaboration."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://onbbits.io/Images/product-catalog.webp"
    );
  }
  }, [])

    return(
        <>
<SchemaMarkup
  data={BreadcrumbSchema({
    items: [
      {
        name: "Home",
        url: "https://onbbits.io/"
      },
      {
        name: "Pricing",
        url: "https://onbbits.io/pricing/"
      }
    ]
  })}
/>
      <SchemaMarkup
  data={WebPageSchema({
    type: "WebPage",
    name: "ONBBITS Pricing",
    description:
      "Explore ONBBITS pricing plans for WhatsApp Business API, automation, customer engagement, campaigns, and business communication.",
    url: "https://onbbits.io/pricing/"
  })}
/>

<SchemaMarkup
  data={ItemListSchema({
    name: "ONBBITS Pricing Plans",
    items: [
      {
        name: "Free"
      },
      {
        name: "Starter"
      },
      {
        name: "Pro"
      },
      {
        name: "Enterprise"
      }
    ]
  })}
/>

<SchemaMarkup
  data={OfferSchema({
    name: "ONBBITS Free Plan",
    description: "ONBBITS free plan for WhatsApp business automation.",
    price: "0",
    priceCurrency: "INR",
    url: "https://onbbits.io/pricing/"
  })}
/>

<SchemaMarkup
  data={OfferSchema({
    name: "ONBBITS Starter Plan",
    description: "ONBBITS Starter plan for WhatsApp business automation.",
    price: "1199",
    priceCurrency: "INR",
    url: "https://onbbits.io/pricing/"
  })}
/>

<SchemaMarkup
  data={OfferSchema({
    name: "ONBBITS Pro Plan",
    description: "ONBBITS Pro plan for WhatsApp business automation.",
    price: "2999",
    priceCurrency: "INR",
    url: "https://onbbits.io/pricing/"
  })}
/>

<SchemaMarkup
  data={OfferSchema({
    name: "ONBBITS Enterprise Plan",
    description:
      "ONBBITS Enterprise plan for businesses requiring advanced WhatsApp business automation, customer engagement, campaigns, analytics and team collaboration.",
    url: "https://onbbits.io/pricing/"
  })}
/>

         {/**BREADCRUMB */}
        <Breadcrumb title="Simple, transparent pricing for every business" />

        {/**PRICING CARDS SECTION */}
        <PricingPlans />

        {/**PRICING COMPARISON TABLE */}
        <PricingTable />

        {/**FAQS SECTION */}
        <Faqs />

        {/**CTA SECTION */}
        <Cta />

        </>
    )
}
export default Pricing;